import { useState, useEffect } from 'react';
import { fieldValidator } from '../../utils/yupSchemaCreator';
import { Input, FormControl, IconButton } from '@airbus/components-react';

const currency = { gbp: <>&#163;</>, usd: <>&#36;</>, eur: <>&#8364;</> };
export default function FieldText(props) {
  const {
    rowId,
    initialValues,
    name,
    label,
    required,
    disabled,
    blurHandler,
    field,
    language,
    handleEnterTabBlur,
  } = props;
  const [value, setValue] = useState(initialValues[name] ?? '');
  const [error, setError] = useState(null);
  const [adornment, setAdornment] = useState(null);
  const [touched, setTouched] = useState(false);

  useEffect(() => {
    if (initialValues) {
      setValue(initialValues[name]);
      let isTouched = false;
      if (
        initialValues?.isCommitRow ||
        (initialValues?.status === 'E' && initialValues?.backup?.[name] !== initialValues[name]) ||
        ((initialValues?.status === 'N' || initialValues?.status === 'C') &&
          initialValues?.touched[name])
      ) {
        isTouched = true;
      }

      setTouched(isTouched);
      if (isTouched) {
        const error = fieldValidator(field, initialValues[name], language);
        setError(error);
      }

      if (field.type === 'price' && field.currency_col_internal_name) {
        const currencyValue = initialValues[field.currency_col_internal_name];
        const symbolName = currencyValue?.toLowerCase();
        setAdornment(symbolName ?? null);
      }
    }
  }, [initialValues]);

  const handleChange = (e) => {
    const newValue = e.target.value;
    const error = fieldValidator(field, newValue, language);
    setError(error);
    if (
      (!error || newValue === '') &&
      (newValue.length >= field.attrMinValue || field.attrMinValue === null) &&
      (newValue.length <= field.attrMaxValue || field.attrMaxValue === null)
    ) {
      setValue(e.target.value);
    }
  };

  const handleFocus = () => {
    setTouched(true);
  };

  const handleBlur = () => {
    if (initialValues[name] === value) {
      return;
    }
    blurHandler(name, value);
    if (field?.onValueChange) {
      field.onValueChange({ rowId, value, row: initialValues });
    }
  };

  return (
    <FormControl
      id={name}
      error={touched && Boolean(error)}
      {...{ label, required, disabled }}
      helpText={touched && error?.msg}
      errorText={touched && error?.msg}
      className='disabled-input'
    >
      {field.type === 'price' ? (
        <Input
          {...{ name }}
          size='small'
          startAdornment={
            <IconButton
              style={{ background: 'none', cursor: 'default', minWidth: '1rem', paddingLeft: '0' }}
              variant='ghost'
              size='small'
              disabled={disabled}
            >
              {currency?.[adornment]}
            </IconButton>
          }
          value={value ?? ''}
          onChange={handleChange}
          onBlur={handleBlur}
          onKeyDown={handleEnterTabBlur}
          onFocus={handleFocus}
          readOnly={disabled}
        />
      ) : (
        <Input
          {...{ name }}
          value={value ?? ''}
          size='small'
          onChange={handleChange}
          onBlur={handleBlur}
          onKeyDown={handleEnterTabBlur}
          onFocus={handleFocus}
          readOnly={disabled}
        />
      )}
    </FormControl>
  );
}
